import {mapActions} from 'vuex';

const prakerjaChangePhoneNumber = {
  data() {
    return {
      isShowChangePhoneNumber: false,
      platform: window.location.origin?.includes('m.') ? 'bl_mobile_web' : 'bl_web',
      storageName: 'hide-phone-number-update',
    };
  },
  async mounted() {
    const isChangePhoneNumberActive = await this.fetchChangePhoneNumberToggle(this.platform);
    if (!window.USER?.phone && this.getIncrementHidePhoneNumber() < 2 && isChangePhoneNumberActive && this.isLogin) {
      this.isShowChangePhoneNumber = true;
      this.$tracker.event({action: 'change_phone_number_show', ...this.payloadTrackerPrakerjaPhoneNumber});
    }
  },
  computed: {
    changePhoneNumberPageUrl() {
      const backUrl = encodeURIComponent(window.location.href);
      return `/phone_settings?comeback=${backUrl}`;
    },
    payloadTrackerPrakerjaPhoneNumber() {
      return {
        evn: 'vp_prakerja_phone_number',
        source: this.$route.name === 'landing' ? 'home_page' : this.$route.name,
        ui: window.USER.id36,
      };
    },
    isLogin() {
      return window.USER.id !== '' && window.USER.id !== null;
    },
  },
  methods: {
    ...mapActions('courses', ['fetchChangePhoneNumberToggle']),
    updateShowModal(isShowModal) {
      this.isShowChangePhoneNumber = isShowModal;
      if (!isShowModal) {
        this.$tracker.event({action: 'nanti_saja_click', ...this.payloadTrackerPrakerjaPhoneNumber});
        this.setIncrementHidePhoneNumber();
      }
    },
    setIncrementHidePhoneNumber() {
      let value = parseInt(localStorage.getItem(this.storageName)) || 0;
      value += 1;
      localStorage.setItem(this.storageName, value);
    },
    getIncrementHidePhoneNumber() {
      return parseInt(localStorage.getItem(this.storageName)) || 0;
    },
    async goToChangePhoneNumberPage() {
      await this.$tracker.event({action: 'change_phone_number_click', ...this.payloadTrackerPrakerjaPhoneNumber});
      window.location.href = this.changePhoneNumberPageUrl;
    },
  },
};

export default prakerjaChangePhoneNumber;
